import {OptionsObject, VariantType} from 'notistack';

import I18n from '@utils/i18n.utils';

const getErrorFromMessage = (message: string): string => {
  const errorTexts: { [key: string]: string } = {
    'MISSING_MAIN_EXECUTION': I18n.t('errors.missingMainExecution'),
    'LINES_CANNOT_EXCEED_2500': I18n.t('errors.linesCannotExceed2500'),
    'EXECUTION_LINE_READY_FOR_INVOICING_ARE_FROM_DIFFERENT_SUPPLIER': I18n.t('errors.multipleSupplierInPurchaseStatementNotAllowed'),
    'SUPPLIER_INVOICE_ALREADY_EXISTS_WITH_THIS_NUMBER': I18n.t('errors.supplierInvoiceAlreadyExistsWithThisNumber'),
    'CANNOT_DELETE_EXECUTION_WITH_INVOICE_LINES': I18n.t('errors.cannotDeleteExecutionWithInvoiceLines'),
    'INDEXATION_ALREADY_EXISTS': I18n.t('errors.indexationAlreadyExists'),
    'CANNOT_UPDATE_WASTE_CONTAINER_FOR_SERVICES_WITH_EXECUTIONS': I18n.t('errors.cannotUpdateWasteContainerForServicesWithExecutions'),
  };

  return errorTexts[message] || I18n.t('errors.global');
};

class SnackError extends Error {
  private readonly text: string;
  private readonly options: OptionsObject;
  public data: any;

  constructor(errorMessage: string, variant: VariantType, customMessage?: boolean, data?: any, ...params: any[]) {
    super(...params);

    this.name = 'SnackError';

    this.text = customMessage ? errorMessage : getErrorFromMessage(errorMessage);
    this.options = {variant};
    this.data = data;
  }
}

export default SnackError;
